"use client";

import { StudioImageField } from "@/app/studio/pages/[slug]/StudioImageField";

export function studioImageField(label = "Image URL / upload") {
  return {
    type: "custom" as const,
    label,
    render: ({
      value,
      onChange,
    }: {
      value: string;
      onChange: (value: string) => void;
    }) => (
      <StudioImageField
        value={typeof value === "string" ? value : ""}
        onChange={onChange}
      />
    ),
  };
}
